import { useMemo } from 'react'
import { CartItemsV3Query } from '~/__generated__/app/query/Cart/Cart.graphql'
import {
  filterChosenAndAvailableOptions,
  getTrainPackageDiscountAmount,
  mapTrainPackageDiscountOptions,
  MergerCartItemOptions,
} from '~/app/utils/TrainHelper'

export default function useCartTrainPackageDiscountHooks(
  cartItems: CartItemsV3Query['cartItemsV3'],
  count
) {
  // 장바구니 내의 상품의 options 를 하나의 배열로 제공
  const mergeItems = useMemo<MergerCartItemOptions>(() => {
    return cartItems.map(item => item.options ?? []).flat()
  }, [cartItems])

  // 선택한 상품 기준으로 적용 가능한 묶음할인 가격 계산
  const chosenTrainPackageDiscountAmount = useMemo<number>(() => {
    const availableChosenItems = filterChosenAndAvailableOptions(mergeItems)
    const formattedItemArray = mapTrainPackageDiscountOptions(availableChosenItems)
    return getTrainPackageDiscountAmount(formattedItemArray)
  }, [cartItems])

  // 현재 장바구니 내에 선택된 상품들로 묶음할인 가능 여부
  const isTrainPackageDiscountAvailable = useMemo(() => {
    return (
      chosenTrainPackageDiscountAmount > 0 &&
      count.availableCheckedTrain > 0 &&
      count.availableCheckedAccommodation > 0
    )
  }, [chosenTrainPackageDiscountAmount, count])

  return {
    chosenTrainPackageDiscountAmount,
    isTrainPackageDiscountAvailable,
  }
}
